import { render, staticRenderFns } from "./StaticForm.vue?vue&type=template&id=0a0f2ac3&"
import script from "./StaticForm.ts?vue&type=script&lang=ts&"
export * from "./StaticForm.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports